export const CATEGORIES = 'categories';
export const BEHAVIOR = 'behavior';
export const UNITS = 'units';
